import { render } from "./PartnerViewMenu.vue?vue&type=template&id=4517c97e"
import script from "./PartnerViewMenu.vue?vue&type=script&lang=ts"
export * from "./PartnerViewMenu.vue?vue&type=script&lang=ts"

import "./PartnerViewMenu.vue?vue&type=style&index=0&id=4517c97e&lang=scss"
script.render = render

export default script